export enum AlerterTypes {
  error = 'error',
  success = 'success',
}
